var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.link
    ? _c(
        "div",
        { staticClass: "tag", class: [_vm.colour, _vm.background] },
        [
          _c("nuxt-link", { attrs: { to: _vm.link } }, [
            _vm._v(_vm._s(_vm.text)),
          ]),
        ],
        1
      )
    : _c("div", { staticClass: "tag", class: [_vm.colour, _vm.background] }, [
        _c("span", [_vm._v(_vm._s(_vm.text))]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }